import type { RpcContract } from "./rpc";
import { adminBrandsRpcContract } from "./rpc/admin-brands";
import { adminInfluencersRpcContract } from "./rpc/admin-influencers";
import { adminUpdateFanRpcContract } from "./rpc/admin-update-fan";
import { adminFansRpcContract } from "./rpc/admin-fans";
import { AdminSendEmailVerifyRpcContract } from "./rpc/admin-send-email-verify";
import { analyticsRpcContract } from "./rpc/analytics";
import { authRpcContract } from "./rpc/auth";
import { brandsSearchRpcContract } from "./rpc/brands-search";
import { bulkImportCreatorsRpcContract } from "./rpc/bulk-import-creators";
import { bulkImportLogsRpcContract } from "./rpc/bulk-import-logs";
import { changeEmailRpcContract } from "./rpc/change-email";
import { checkHandleRpcContract } from "./rpc/check-handle";
import { createBrandRpcContract } from "./rpc/create-brand";
import { createCreatorRpcContract } from "./rpc/create-creator";
import { createInfluencerAdminRpcContract } from "./rpc/create-influencer-admin";
import { createPostRpcContract } from "./rpc/create-post";
import { createUnifiedLinkRpcContract } from "./rpc/create-unified-link";
import { createWorldRpcContract } from "./rpc/create-world";
import { deletePostRpcContract } from "./rpc/delete-post";
import { deleteUnifiedLinkRpcContract } from "./rpc/delete-unified-link";
import { deleteUserRpcContract } from "./rpc/delete-user";
import { deleteWorldRpcContract } from "./rpc/delete-world";
import { getBrandRpcContract } from "./rpc/get-brand";
import { getPostRpcContract } from "./rpc/get-post";
import { getFileUploadUrlRpcContract } from "./rpc/getFileUploadUrl";
import { impersonateInfluencerRpcContract } from "./rpc/impersonate-influencer";
import { linksQueryRpcContract } from "./rpc/links-query";
import { postsQueryRpcContract } from "./rpc/posts-query";
import { profileColorsRpcContract } from "./rpc/profile-colors";
import { profileDataRpcContract } from "./rpc/profile-data";
import { publicPostDetailQueryRpcContract } from "./rpc/public-post-detail-query";
import { publicPostsQueryRpcContract } from "./rpc/public-posts-query";
import { publicProfileDataRpcContract } from "./rpc/public-profile-data";
import { publicUnifiedLinksRpcContract } from "./rpc/public-unified-links";
import { publicWorldsQueryRpcContract } from "./rpc/public-worlds-query";
import { requestPasswordResetRpcContract } from "./rpc/request-password-reset";
import { resetPasswordRpcContract } from "./rpc/reset-password";
import { changePasswordRpcContract } from "./rpc/change-password";
import { resendOTPRpcContract } from "./rpc/resend-otp";
import { saveProfileRpcContract } from "./rpc/save-profile";
import { sendChangeEmailVerificationRpcContract } from "./rpc/send-change-email-verification";
import { signUpRpcContract } from "./rpc/sign-up";
import { socialLinksRpcContract } from "./rpc/social-links";
import { subscribeConfirmationRpcContract } from "./rpc/subscribe-confirmation";
import { trackAnalyticsRpcContract } from "./rpc/track-analytics";
import { unlockExclusiveHighlightRpcContract } from "./rpc/unlock-exclusive-highlight";
import { updateBrandRpcContract } from "./rpc/update-brand";
import { updateInfluencerRpcContract } from "./rpc/update-influencer";
import { updatePostRpcContract } from "./rpc/update-post";
import { updateProfileRpcContract } from "./rpc/update-profile";
import { updateUnifiedLinkRpcContract } from "./rpc/update-unified-link";
import { updateWorldRpcContract } from "./rpc/update-world";
import { urlEnricherRpcContract } from "./rpc/url-enricher";
import { verifyEmailRpcContract } from "./rpc/verify-email";
import { worldsQueryRpcContract } from "./rpc/worlds-query";
import {
  socialAuthInitRpcContract,
  socialAuthCallbackRpcContract,
  socialAuthLinkRpcContract,
  socialAuthUnlinkRpcContract,
  getLinkedProvidersRpcContract,
} from "./rpc/social-auth";
import { getUnifiedLinksRpcContract } from "./rpc/get-unified-links";
import { getUnifiedLinkRpcContract } from "./rpc/get-unified-link";
import { updateUnifiedLinksOrderRpcContract } from "./rpc/update-unified-links-order";
import { setExclusiveUnifiedLinkRpcContract } from "./rpc/set-exclusive-unified-link";
import { setWaitingListLinkRpcContract } from "./rpc/set-waiting-list-link";
import { submitWaitingListRpcContract } from "./rpc/submit-waiting-list";
import { verifyWaitingListEmailRpcContract } from "./rpc/verify-waiting-list-email";
import { createFeedbackRpcContract } from "./rpc/create-feedback";
import { getFeedbacksRpcContract } from "./rpc/get-feedbacks";
import { getFeedbackRpcContract } from "./rpc/get-feedback";
import { contentThemesRpcContract } from "./rpc/content-themes";
import { saveUserThemesRpcContract } from "./rpc/save-user-themes";
import { updateUserPreferencesRpcContract } from "./rpc/update-user-preferences";
import { getCreatorsRpcContract } from "./rpc/get-creators";
import { followCreatorsRpcContract } from "./rpc/follow-creators";
import { getPublicDiscountsRpcContract } from "./rpc/get-public-discounts";
import { getFanCreatorsRpcContract } from "./rpc/get-fan-creators";
import { getFanDiscountsRpcContract } from "./rpc/get-fan-discounts";
import { getEventLinkedDiscountsRpcContract } from "./rpc/get-event-linked-discounts";
import { authSessionRpcContract } from "./rpc/auth-session";
import { signOutRpcContract } from "./rpc/sign-out";
import { isFollowingCreatorRpcContract } from "./rpc/is-following-creator";
import { unfollowCreatorRpcContract } from "./rpc/unfollow-creator";
import { getNotificationsRpcContract, markAllNotificationsReadRpcContract } from "./rpc/notifications";
import { sendMailAddressValidationEmailRpcContract } from "./rpc/send-mail-address-validation-email";
import { saveEmailCustomizationRpcContract } from "./rpc/save-email-customization";
import { getEmailCustomizationRpcContract } from "./rpc/get-email-customization";
import { deleteEmailCustomizationRpcContract } from "./rpc/delete-email-customization";
import { checkContentAccessRpcContract } from "./rpc/check-content-access";
import { createSubscriptionCheckoutRpcContract } from "./rpc/create-subscription-checkout";
import { createOneTimeCheckoutRpcContract } from "./rpc/create-one-time-checkout";
import { getCheckoutStatusRpcContract } from "./rpc/get-checkout-status";
import { getCreatorSubscriptionInfoRpcContract } from "./rpc/get-creator-subscription-info";
import { getMySubscriptionsRpcContract } from "./rpc/get-my-subscriptions";
import { getMySubscriptionTierRpcContract } from "./rpc/get-my-subscription-tier";
import { createSubscriptionTierRpcContract } from "./rpc/create-subscription-tier";
import { updateSubscriptionTierRpcContract } from "./rpc/update-subscription-tier";
import { deactivateSubscriptionTierRpcContract } from "./rpc/deactivate-subscription-tier";
import { updateContentTierRpcContract } from "./rpc/update-content-tier";
import { enableOneTimePurchaseRpcContract } from "./rpc/enable-one-time-purchase";
import { disableOneTimePurchaseRpcContract } from "./rpc/disable-one-time-purchase";
import { createLiveEventRpcContract } from "./rpc/create-live-event";
import { deleteLiveEventRpcContract } from "./rpc/delete-live-event";
import { archiveLiveEventRpcContract } from "./rpc/archive-live-event";
import { endLiveEventRpcContract } from "./rpc/end-live-event";
import { getLiveEventByIdRpcContract } from "./rpc/get-live-event-by-id";
import { getLiveEventsRpcContract } from "./rpc/get-live-events";
import { getPublicLiveEventsRpcContract } from "./rpc/get-public-live-events";
import { getFanPurchasedLiveEventsRpcContract } from "./rpc/get-fan-purchased-live-events";
import { getFanJoinedCommunitiesRpcContract } from "./rpc/get-fan-joined-communities";
import { startLiveEventRpcContract } from "./rpc/start-live-event";
import { stopLiveEventRpcContract } from "./rpc/stop-live-event";
import { updateLiveEventRpcContract } from "./rpc/update-live-event";
import { saveDraftLiveEventRpcContract } from "./rpc/save-draft-live-event";
import { publishDraftLiveEventRpcContract } from "./rpc/publish-draft-live-event";
import { registerFreeLiveEventRpcContract } from "./rpc/register-free-live-event";
import { ingestTelemetryRpcContract } from "./rpc/ingest-telemetry";
import { ingestBroadcasterTelemetryRpcContract } from "./rpc/ingest-broadcaster-telemetry";

// Guest checkout / Fan account creation
import { checkEmailExistsRpcContract } from "./rpc/check-email-exists";
import { createGuestAccountRpcContract } from "./rpc/create-guest-account";
import { createFanAccountRpcContract } from "./rpc/create-fan-account";
import { resendPurchaseVerificationEmailRpcContract } from "./rpc/resend-purchase-verification-email";

// Feature Flags
import {
  checkFeatureFlagRpcContract,
  getMyFeatureFlagsRpcContract,
  enableFeatureForUsersRpcContract,
  disableFeatureForUsersRpcContract,
  enableFeatureByEmailsRpcContract,
  disableFeatureByEmailsRpcContract,
} from "./rpc/feature-flags";

// Checkout auth token
import { verifyCheckoutAuthTokenRpcContract } from "./rpc/verify-checkout-auth-token";

// Live Chat
import { sendLiveChatMessageRpcContract, getLiveChatMessagesRpcContract } from "./rpc/live-chat";

// Live Event Access Request
import {
  requestLiveEventAccessRpcContract,
  getLiveEventAccessRequestRpcContract,
} from "./rpc/live-event-access-request";

// Creator Messages
import {
  getMessageSegmentsRpcContract,
  createCreatorMessageRpcContract,
  updateCreatorMessageRpcContract,
  getCreatorMessageByIdRpcContract,
  deleteCreatorMessageRpcContract,
  archiveCreatorMessageRpcContract,
} from "./rpc/creator-message";
import { getCreatorMessagesRpcContract } from "./rpc/get-creator-messages";
import { sendCreatorMessageRpcContract } from "./rpc/send-creator-message";

// Recording
import { updateRecordingStatusRpcContract } from "./rpc/update-recording-status";

// Email Jobs
import { updateEmailJobStatusRpcContract } from "./rpc/update-email-job-status";
import { generateVerificationUrlRpcContract } from "./rpc/generate-verification-url";
import { getRecordingStatusRpcContract } from "./rpc/get-recording-status";
import { enqueueRecordingRpcContract } from "./rpc/enqueue-recording";

// Creator Mute Preferences
import { getMutedCreatorsRpcContract, muteCreatorRpcContract, unmuteCreatorRpcContract } from "./rpc/user-creator-mute";

// Communities
import {
  createCommunityRpcContract,
  updateCommunityRpcContract,
  deleteCommunityRpcContract,
  getCommunitiesRpcContract,
  archiveCommunityRpcContract,
  duplicateCommunityRpcContract,
  linkCommunityEventRpcContract,
  unlinkCommunityEventRpcContract,
  getCommunityEventsRpcContract,
  getPublicCommunitiesRpcContract,
  getPublicCommunityRpcContract,
  joinCommunityRpcContract,
  sendCommunityChatMessageRpcContract,
  getCommunityChatMessagesRpcContract,
} from "./rpc/community";
import { updateCommunitiesOrderRpcContract } from "./rpc/update-communities-order";
import {
  createCoPromotionRpcContract,
  revokeCoPromotionRpcContract,
  getCoPromotersForEntityRpcContract,
  getMyCoPromotionsRpcContract,
  searchCreatorForCoPromotionRpcContract,
} from "./rpc/co-promotion";

export const rpcContracts = {
  [adminBrandsRpcContract.name]: adminBrandsRpcContract,
  [adminInfluencersRpcContract.name]: adminInfluencersRpcContract,
  [adminFansRpcContract.name]: adminFansRpcContract,
  [adminUpdateFanRpcContract.name]: adminUpdateFanRpcContract,
  [AdminSendEmailVerifyRpcContract.name]: AdminSendEmailVerifyRpcContract,
  [bulkImportCreatorsRpcContract.name]: bulkImportCreatorsRpcContract,
  [bulkImportLogsRpcContract.name]: bulkImportLogsRpcContract,
  [authRpcContract.name]: authRpcContract,
  [brandsSearchRpcContract.name]: brandsSearchRpcContract,
  [createPostRpcContract.name]: createPostRpcContract,
  [createBrandRpcContract.name]: createBrandRpcContract,
  [createCreatorRpcContract.name]: createCreatorRpcContract,
  [createInfluencerAdminRpcContract.name]: createInfluencerAdminRpcContract,
  [impersonateInfluencerRpcContract.name]: impersonateInfluencerRpcContract,
  [getBrandRpcContract.name]: getBrandRpcContract,
  [getPostRpcContract.name]: getPostRpcContract,
  [updateBrandRpcContract.name]: updateBrandRpcContract,
  [updateInfluencerRpcContract.name]: updateInfluencerRpcContract,
  [updatePostRpcContract.name]: updatePostRpcContract,
  [getFileUploadUrlRpcContract.name]: getFileUploadUrlRpcContract,
  [publicUnifiedLinksRpcContract.name]: publicUnifiedLinksRpcContract,
  [linksQueryRpcContract.name]: linksQueryRpcContract,
  [postsQueryRpcContract.name]: postsQueryRpcContract,
  [profileColorsRpcContract.name]: profileColorsRpcContract,
  [profileDataRpcContract.name]: profileDataRpcContract,
  [publicProfileDataRpcContract.name]: publicProfileDataRpcContract,
  [publicWorldsQueryRpcContract.name]: publicWorldsQueryRpcContract,
  [publicPostsQueryRpcContract.name]: publicPostsQueryRpcContract,
  [publicPostDetailQueryRpcContract.name]: publicPostDetailQueryRpcContract,
  [saveProfileRpcContract.name]: saveProfileRpcContract,
  [socialLinksRpcContract.name]: socialLinksRpcContract,
  [verifyEmailRpcContract.name]: verifyEmailRpcContract,
  [checkHandleRpcContract.name]: checkHandleRpcContract,
  [worldsQueryRpcContract.name]: worldsQueryRpcContract,
  [createWorldRpcContract.name]: createWorldRpcContract,
  [signUpRpcContract.name]: signUpRpcContract,
  [deleteWorldRpcContract.name]: deleteWorldRpcContract,
  [updateWorldRpcContract.name]: updateWorldRpcContract,
  [analyticsRpcContract.name]: analyticsRpcContract,
  [deletePostRpcContract.name]: deletePostRpcContract,
  [trackAnalyticsRpcContract.name]: trackAnalyticsRpcContract,
  [subscribeConfirmationRpcContract.name]: subscribeConfirmationRpcContract,
  [requestPasswordResetRpcContract.name]: requestPasswordResetRpcContract,
  [resetPasswordRpcContract.name]: resetPasswordRpcContract,
  [changePasswordRpcContract.name]: changePasswordRpcContract,
  [updateProfileRpcContract.name]: updateProfileRpcContract,
  [sendChangeEmailVerificationRpcContract.name]: sendChangeEmailVerificationRpcContract,
  [deleteUserRpcContract.name]: deleteUserRpcContract,
  [unlockExclusiveHighlightRpcContract.name]: unlockExclusiveHighlightRpcContract,
  [changeEmailRpcContract.name]: changeEmailRpcContract,
  [resendOTPRpcContract.name]: resendOTPRpcContract,
  [socialAuthInitRpcContract.name]: socialAuthInitRpcContract,
  [socialAuthCallbackRpcContract.name]: socialAuthCallbackRpcContract,
  [socialAuthLinkRpcContract.name]: socialAuthLinkRpcContract,
  [socialAuthUnlinkRpcContract.name]: socialAuthUnlinkRpcContract,
  [getLinkedProvidersRpcContract.name]: getLinkedProvidersRpcContract,
  [urlEnricherRpcContract.name]: urlEnricherRpcContract,
  [createUnifiedLinkRpcContract.name]: createUnifiedLinkRpcContract,
  [updateUnifiedLinkRpcContract.name]: updateUnifiedLinkRpcContract,
  [deleteUnifiedLinkRpcContract.name]: deleteUnifiedLinkRpcContract,
  [getUnifiedLinksRpcContract.name]: getUnifiedLinksRpcContract,
  [getUnifiedLinkRpcContract.name]: getUnifiedLinkRpcContract,
  [updateUnifiedLinksOrderRpcContract.name]: updateUnifiedLinksOrderRpcContract,
  [setExclusiveUnifiedLinkRpcContract.name]: setExclusiveUnifiedLinkRpcContract,
  [authSessionRpcContract.name]: authSessionRpcContract,
  [signOutRpcContract.name]: signOutRpcContract,

  // Feedback
  [createFeedbackRpcContract.name]: createFeedbackRpcContract,
  [getFeedbacksRpcContract.name]: getFeedbacksRpcContract,
  [getFeedbackRpcContract.name]: getFeedbackRpcContract,

  // Content categories
  [contentThemesRpcContract.name]: contentThemesRpcContract,
  [saveUserThemesRpcContract.name]: saveUserThemesRpcContract,

  // User preferences
  [updateUserPreferencesRpcContract.name]: updateUserPreferencesRpcContract,

  // Creator discovery and following
  [getCreatorsRpcContract.name]: getCreatorsRpcContract,
  [followCreatorsRpcContract.name]: followCreatorsRpcContract,
  [isFollowingCreatorRpcContract.name]: isFollowingCreatorRpcContract,
  [unfollowCreatorRpcContract.name]: unfollowCreatorRpcContract,
  [getPublicDiscountsRpcContract.name]: getPublicDiscountsRpcContract,
  [getFanCreatorsRpcContract.name]: getFanCreatorsRpcContract,
  [getFanDiscountsRpcContract.name]: getFanDiscountsRpcContract,
  [getEventLinkedDiscountsRpcContract.name]: getEventLinkedDiscountsRpcContract,

  // Notifications
  [getNotificationsRpcContract.name]: getNotificationsRpcContract,
  [markAllNotificationsReadRpcContract.name]: markAllNotificationsReadRpcContract,
  [sendMailAddressValidationEmailRpcContract.name]: sendMailAddressValidationEmailRpcContract,

  [saveEmailCustomizationRpcContract.name]: saveEmailCustomizationRpcContract,
  [getEmailCustomizationRpcContract.name]: getEmailCustomizationRpcContract,
  [deleteEmailCustomizationRpcContract.name]: deleteEmailCustomizationRpcContract,

  // Stripe Subscriptions & Paywall (Batch 2 - Fan RPCs)
  [checkContentAccessRpcContract.name]: checkContentAccessRpcContract,
  [createSubscriptionCheckoutRpcContract.name]: createSubscriptionCheckoutRpcContract,
  [createOneTimeCheckoutRpcContract.name]: createOneTimeCheckoutRpcContract,
  [getCheckoutStatusRpcContract.name]: getCheckoutStatusRpcContract,
  [getCreatorSubscriptionInfoRpcContract.name]: getCreatorSubscriptionInfoRpcContract,
  [getMySubscriptionsRpcContract.name]: getMySubscriptionsRpcContract,
  // Stripe subscription and payment RPCs
  [getMySubscriptionTierRpcContract.name]: getMySubscriptionTierRpcContract,
  [createSubscriptionTierRpcContract.name]: createSubscriptionTierRpcContract,
  [updateSubscriptionTierRpcContract.name]: updateSubscriptionTierRpcContract,
  [deactivateSubscriptionTierRpcContract.name]: deactivateSubscriptionTierRpcContract,
  [updateContentTierRpcContract.name]: updateContentTierRpcContract,
  [enableOneTimePurchaseRpcContract.name]: enableOneTimePurchaseRpcContract,
  [disableOneTimePurchaseRpcContract.name]: disableOneTimePurchaseRpcContract,

  // Live Events
  [createLiveEventRpcContract.name]: createLiveEventRpcContract,
  [getLiveEventByIdRpcContract.name]: getLiveEventByIdRpcContract,
  [getLiveEventsRpcContract.name]: getLiveEventsRpcContract,
  [getPublicLiveEventsRpcContract.name]: getPublicLiveEventsRpcContract,
  [getFanPurchasedLiveEventsRpcContract.name]: getFanPurchasedLiveEventsRpcContract,
  [updateLiveEventRpcContract.name]: updateLiveEventRpcContract,
  [deleteLiveEventRpcContract.name]: deleteLiveEventRpcContract,
  [archiveLiveEventRpcContract.name]: archiveLiveEventRpcContract,
  [startLiveEventRpcContract.name]: startLiveEventRpcContract,
  [stopLiveEventRpcContract.name]: stopLiveEventRpcContract,
  [endLiveEventRpcContract.name]: endLiveEventRpcContract,
  [saveDraftLiveEventRpcContract.name]: saveDraftLiveEventRpcContract,
  [publishDraftLiveEventRpcContract.name]: publishDraftLiveEventRpcContract,
  [registerFreeLiveEventRpcContract.name]: registerFreeLiveEventRpcContract,

  // Telemetry
  [ingestTelemetryRpcContract.name]: ingestTelemetryRpcContract,
  [ingestBroadcasterTelemetryRpcContract.name]: ingestBroadcasterTelemetryRpcContract,

  // Guest checkout / Fan account creation
  [checkEmailExistsRpcContract.name]: checkEmailExistsRpcContract,
  [createGuestAccountRpcContract.name]: createGuestAccountRpcContract,
  [createFanAccountRpcContract.name]: createFanAccountRpcContract,
  [resendPurchaseVerificationEmailRpcContract.name]: resendPurchaseVerificationEmailRpcContract,

  // Checkout auth token (for cross-browser login after Stripe redirect)
  [verifyCheckoutAuthTokenRpcContract.name]: verifyCheckoutAuthTokenRpcContract,

  // Feature Flags
  [checkFeatureFlagRpcContract.name]: checkFeatureFlagRpcContract,
  [getMyFeatureFlagsRpcContract.name]: getMyFeatureFlagsRpcContract,
  [enableFeatureForUsersRpcContract.name]: enableFeatureForUsersRpcContract,
  [disableFeatureForUsersRpcContract.name]: disableFeatureForUsersRpcContract,
  [enableFeatureByEmailsRpcContract.name]: enableFeatureByEmailsRpcContract,
  [disableFeatureByEmailsRpcContract.name]: disableFeatureByEmailsRpcContract,

  // Live Chat
  [sendLiveChatMessageRpcContract.name]: sendLiveChatMessageRpcContract,
  [getLiveChatMessagesRpcContract.name]: getLiveChatMessagesRpcContract,

  // Waiting List
  [submitWaitingListRpcContract.name]: submitWaitingListRpcContract,
  [verifyWaitingListEmailRpcContract.name]: verifyWaitingListEmailRpcContract,
  [setWaitingListLinkRpcContract.name]: setWaitingListLinkRpcContract,

  // Live Event Access Request
  [requestLiveEventAccessRpcContract.name]: requestLiveEventAccessRpcContract,
  [getLiveEventAccessRequestRpcContract.name]: getLiveEventAccessRequestRpcContract,

  // Creator Messages
  [getMessageSegmentsRpcContract.name]: getMessageSegmentsRpcContract,
  [createCreatorMessageRpcContract.name]: createCreatorMessageRpcContract,
  [updateCreatorMessageRpcContract.name]: updateCreatorMessageRpcContract,
  [getCreatorMessageByIdRpcContract.name]: getCreatorMessageByIdRpcContract,
  [deleteCreatorMessageRpcContract.name]: deleteCreatorMessageRpcContract,
  [archiveCreatorMessageRpcContract.name]: archiveCreatorMessageRpcContract,
  [getCreatorMessagesRpcContract.name]: getCreatorMessagesRpcContract,

  // Recording
  [updateRecordingStatusRpcContract.name]: updateRecordingStatusRpcContract,
  [getRecordingStatusRpcContract.name]: getRecordingStatusRpcContract,
  [enqueueRecordingRpcContract.name]: enqueueRecordingRpcContract,

  // Email Jobs
  [updateEmailJobStatusRpcContract.name]: updateEmailJobStatusRpcContract,

  // Creator Mute Preferences
  [getMutedCreatorsRpcContract.name]: getMutedCreatorsRpcContract,
  [muteCreatorRpcContract.name]: muteCreatorRpcContract,
  [unmuteCreatorRpcContract.name]: unmuteCreatorRpcContract,
  [generateVerificationUrlRpcContract.name]: generateVerificationUrlRpcContract,

  // Creator Messages
  [sendCreatorMessageRpcContract.name]: sendCreatorMessageRpcContract,

  // Communities
  [createCommunityRpcContract.name]: createCommunityRpcContract,
  [updateCommunityRpcContract.name]: updateCommunityRpcContract,
  [deleteCommunityRpcContract.name]: deleteCommunityRpcContract,
  [getCommunitiesRpcContract.name]: getCommunitiesRpcContract,
  [archiveCommunityRpcContract.name]: archiveCommunityRpcContract,
  [duplicateCommunityRpcContract.name]: duplicateCommunityRpcContract,
  [linkCommunityEventRpcContract.name]: linkCommunityEventRpcContract,
  [unlinkCommunityEventRpcContract.name]: unlinkCommunityEventRpcContract,
  [getCommunityEventsRpcContract.name]: getCommunityEventsRpcContract,
  [getPublicCommunitiesRpcContract.name]: getPublicCommunitiesRpcContract,
  [getPublicCommunityRpcContract.name]: getPublicCommunityRpcContract,
  [joinCommunityRpcContract.name]: joinCommunityRpcContract,
  [getFanJoinedCommunitiesRpcContract.name]: getFanJoinedCommunitiesRpcContract,
  [sendCommunityChatMessageRpcContract.name]: sendCommunityChatMessageRpcContract,
  [getCommunityChatMessagesRpcContract.name]: getCommunityChatMessagesRpcContract,
  [updateCommunitiesOrderRpcContract.name]: updateCommunitiesOrderRpcContract,

  // Co-Promotions
  [createCoPromotionRpcContract.name]: createCoPromotionRpcContract,
  [revokeCoPromotionRpcContract.name]: revokeCoPromotionRpcContract,
  [getCoPromotersForEntityRpcContract.name]: getCoPromotersForEntityRpcContract,
  [getMyCoPromotionsRpcContract.name]: getMyCoPromotionsRpcContract,
  [searchCreatorForCoPromotionRpcContract.name]: searchCreatorForCoPromotionRpcContract,
} as const;

//export type RpcContract = (typeof rpcContracts)[keyof typeof rpcContracts];
export type RpcName = keyof typeof rpcContracts;

export type RpcParams<T extends RpcName> =
  (typeof rpcContracts)[T] extends RpcContract<string, infer P, unknown> ? P : never;

export type RpcResult<T extends RpcName> =
  (typeof rpcContracts)[T] extends RpcContract<string, unknown, infer R> ? R : never;
